import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChecklist: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChecklist"><Path fillRule="evenodd" clipRule="evenodd" d="M9.9 5.8001L5.73241 11.3569L2.61325 9.27745L3.72265 7.61335L5.26759 8.64331L8.3 4.6001L9.9 5.8001ZM12 7.0001H21V9.0001H12V7.0001ZM9.9 13.8001L5.73241 19.3569L2.61325 17.2774L3.72265 15.6133L5.26759 16.6433L8.3 12.6001L9.9 13.8001ZM12 15.0001H21V17.0001H12V15.0001Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChecklist;
